import { setAnalytics } from "@actions/setAnalyticsData";
import { setPayloadData } from "@store/slices/globalState";
import { getDataFromStore, numberToMonth } from "@utils/index";
import { useState } from "react";
import { useDispatch } from "react-redux";

// todo: usereducer here
const useMmvState = ({
  initialMake = "",
  initialModal = "",
  initialFuelType = "",
  initialRegYear = "",
  initialVariant = "",
  initialIsCommercial = false,
  initialActiveMonth = "",
  initalActiveYear = "",
  initialVariantEkey = "",
}: any) => {
  const dispatch = useDispatch();

  const [currentStateForMake, setCurrentStateForMake] =
    useState<any>(initialMake);
  const [currentStateForModal, setCurrentStateForModal] =
    useState<any>(initialModal);
  const [currentStateForFuelType, setCurrentStateForFuelType] = useState<any>(
    initialFuelType === "internal_lpg_cng" ? "cng" : initialFuelType
  );
  const [currentStateForRegYear, setCurrentStateForRegYear] = useState<any>(
    initialRegYear ? initialRegYear : "",
  );
  const [currentStateForVariant, setCurrentStateForVariant] =
    useState<any>(initialVariant);
  const [isCommercial, setIsCommercial] = useState<any>(initialIsCommercial);
  const [currentActiveMonth, setCurrentActiveMonth] = useState(
    initialActiveMonth ? numberToMonth(initialActiveMonth) : "",
  );
  const [currentActiveYear, setCurrentActiveYear] = useState(
    initalActiveYear ? initalActiveYear : "",
  );

  if (initialMake && !getDataFromStore("make")) {
    dispatch(setPayloadData({ make: initialMake }));
    setAnalytics({make_name: initialMake})
  }
  if (initialModal && !getDataFromStore("model")) {
    dispatch(setPayloadData({ model: initialModal }));
    setAnalytics({ model_name: initialModal });
  }
  if (initialFuelType && !getDataFromStore("fuel_type")) {
    dispatch(setPayloadData({ fuel_type: initialFuelType }));
    setAnalytics({ fuel_type: initialFuelType });
  }

  if (initialVariant?.variant_name && !getDataFromStore("variant")) {
    dispatch(
      setPayloadData({
        variant: initialVariant?.name
      })
    );
    setAnalytics({ variant_name: initialVariant?.name });
  }

  if (
    typeof initialIsCommercial === "boolean" &&
    !getDataFromStore("is_commercial")
  ) {
    dispatch(
      setPayloadData({
        is_commercial: initialIsCommercial
      })
    );
     setAnalytics({ is_commercial: initialIsCommercial });
  }

  if (initialRegYear && !getDataFromStore("registration_year")) {
    dispatch(
      //@ts-ignore
      setPayloadData({
        registration_year: initialRegYear,
      }),
    );
     setAnalytics({ registration_year: initialRegYear });
  }

  if (initialActiveMonth && !getDataFromStore("registration_month")) {
    dispatch(
      //@ts-ignore
      setPayloadData({
        registration_month: initialActiveMonth,
      }),
    );
     setAnalytics({ registration_month: initialActiveMonth });
  }

  // setAnalytics({
  //   registration_month: initialActiveMonth,
  //   registration_year: initialRegYear,
  //   is_commercial: initialIsCommercial,
  //   is_external_cng_kit: initialExternalCngKit,
  //   variant: initialVariant?.name,
  //   fuel_type: initialFuelType,
  //   make: initialMake,
  //   model: initialModal,
  // });
  // if (initialVariantEkey) {
  //   dispatch(
  //     //@ts-ignore
  //     setPayloadData({
  //       variant_ekey: initialVariantEkey
  //     })
  //   );
  // }
  return {
    currentStateForMake,
    setCurrentStateForMake,
    currentStateForModal,
    setCurrentStateForModal,
    currentStateForFuelType,
    setCurrentStateForFuelType,
    currentStateForRegYear,
    setCurrentStateForRegYear,
    currentStateForVariant,
    setCurrentStateForVariant,
    isCommercial,
    setIsCommercial,
    currentActiveMonth,
    setCurrentActiveMonth,
    currentActiveYear,
    setCurrentActiveYear
  };
};

export default useMmvState;
